export default {
  // 页面标题
  pageTitle: "Aha's DNA",
  
  // 当前网站部分
  currentWebsite: {
    label: "Current website",
    startButton: "Start shaping Aha's DNA"
  },
  
  // 业务名称
  businessName: {
    title: "Business name",
    edit: "Edit",
    save: "Save"
  },
  
  // 业务介绍
  businessIntroduction: {
    title: "Business introduction",
    edit: "Edit",
    save: "Save"
  },
  
  // 竞争对手
  competitors: {
    title: "Competitors",
    edit: "Edit",
    save: "Save"
  },
  
  // 品牌形象
  brandImage: {
    title: "Brand image",
    edit: "Edit",
    save: "Save"
  },
  
  // 语调
  toneOfVoice: {
    title: "Tone of voice",
    edit: "Edit",
    save: "Save",
    newTag: "New Tag"
  },
  
  // 核心卖点
  coreSellingPoints: {
    title: "Core selling points",
    edit: "Edit",
    save: "Save",
    add: "Add",
    addWithCount: "Add ({count})"
  },
  
  // 核心受众
  coreAudiences: {
    title: "Core audiences",
    edit: "Edit",
    save: "Save",
    add: "Add",
    titlePlaceholder: "title",
    contentPlaceholder: "content"
  },
  
  // 加载状态
  loading: "Loading...",
  
  // 通用操作
  actions: {
    edit: "Edit",
    save: "Save",
    delete: "Delete"
  },
  
  // 占位符文本
  placeholders: {
    title: "title",
    content: "content"
  }
};
